import { Role } from '../types/role'

import { api } from '../api'

export const getRoles = (): Promise<Role[]> => {
  return api.get('/api/v1/roles')
}
